import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface GuttersDownspoutsProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const GuttersDownspouts: React.FC<GuttersDownspoutsProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [guttersDownspouts, setGuttersDownspouts] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Exterior Features']?.['Gutters/Downspouts'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Exterior Features': { ...s.values?.['Exterior Features'], 'Gutters/Downspouts': v } } })
    );
    const label = 'Gutters/Downspouts';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={guttersDownspouts}
                />
            ) : (
                <TextBox
                    value={guttersDownspouts ?? ''}
                    onChange={(value) => setGuttersDownspouts(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
